export default function className(classes: Array<string | undefined>) {
  return classes.filter((cls) => !!cls).join(' ');
}
